import { createSlice } from "@reduxjs/toolkit";

import { } from "../actions"
import {
  getCustomerByEmail,
  otpGeneration,
  verifyOtp
} from "./actions"

const initialState = {
  loading: false,
  loadingOtp: false,
  loginStep: 1,
  emailExist: false,
  userName: "",
  customerId: "",
  key: "",
  redirect: false,
  targetRedirect: ""
};

const loginSlice = createSlice({
  name: "login",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCustomerByEmail.fulfilled, (state, action) => {
      state.emailExist = action.payload.success ? true : false;
      state.loading = action.payload.success ? true : false;
      state.userName = action.payload.success ? action.payload.data.firstName : "";
      state.customerId = action.payload.success && action.payload.data.customerId ? action.payload.data.customerId : "";
    });
    builder.addCase(getCustomerByEmail.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getCustomerByEmail.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(otpGeneration.fulfilled, (state, action) => {
      state.loginStep = action.payload.success ? 2 : 1;
      state.loadingOtp = false;
      state.loading = false;
      state.key = action.payload && action.payload.success ? action.payload.data.key : "";
    });
    builder.addCase(otpGeneration.pending, (state, action) => {
      state.loadingOtp = true;
    });
    builder.addCase(otpGeneration.rejected, (state, action) => {
      state.loadingOtp = false;
    });

    builder.addCase(verifyOtp.fulfilled, (state, action) => {
      state.loading = false;
      state.otpVerified = action.payload.success?true:false;
      state.targetRedirect = action.payload.success ? "/mySubscriptions":""
    });
    builder.addCase(verifyOtp.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(verifyOtp.rejected, (state, action) => {
      state.loading = false;
    });
  }
});

export default loginSlice.reducer;